module.exports = __webpack_public_path__ + "static/img/Temperance.71c4666.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Temperance.jpg
// module id = 1303
// module chunks = 0